module.exports = __webpack_public_path__ + "static/img/protection-03.7665a33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/protection-03.png
// module id = 137
// module chunks = 0